import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';
import * as Sentry from '@sentry/browser';
import { fetchPOSData } from '@olxbr/mojo-jojo/thunks/pos';
import { getPOSData } from '@olxbr/mojo-jojo/selectors/pos';
import { getExtrasData } from '@olxbr/mojo-jojo/selectors/extras';
import { getAdData } from '@olxbr/mojo-jojo/selectors/ad';

import PointOfSale from './PointOfSales';
import { toggleLoader } from './core/actions';
import withLoader from './core/enhancements/withLoader';
import { isLoading } from './core/selectors';
import { getSource, getTestABGroups } from './core/libs/browser/browser';
import { sendPageView } from './core/services/tracking';

const withInitialFetch = lifecycle({
  componentDidMount() {
    const {
      REACT_APP_OCTOPOS_HOST,
      REACT_APP_ERROR_HOST,
      REACT_APP_ERROR_MYADS_REDIRECT,
      REACT_APP_ERROR_MYADS_REDIRECT_MSITE,
    } = process.env;
    const referralParam = document.location.search.match(/referral=([a-zA-Z_-]*)/);
    const referral = referralParam ? referralParam[1] : '';
    getTestABGroups();
    const platform = getSource();
    this.props.fetchPOSData(this.props, REACT_APP_OCTOPOS_HOST, { 'X-Platform': platform, 'X-Referral': referral })
      .then((data) => {
        const {
          legacyAdId: adId,
          listId,
          categoryId,
          categoryName,
          zipcode,
          region,
        } = data.adInfo || {};
        const { publicAccountId } = data.userInfo || {};
        const { parentName, funnelId } = data.meta || {};
        const { highlights, subscriptions } = data;
        const products = [...highlights, ...subscriptions];
        const productNames = products.map(p => p.type).join();
        const productPrices = products.map(p => p.totalPrice).join();

        window.pushToDataLayer(categoryName, categoryId, publicAccountId);
        sendPageView({
          adId,
          listId,
          categoryId,
          publicAccountId,
          pointOfSale: parentName,
          referral,
          funnelId,
          productNames,
          productPrices,
          zipcode,
          region,
        });
      })
      .catch((error) => {
        const getErrorURL = () => {
          const standalone = window.location.search.match(/adId|listId/) === null;

          if (standalone) {
            return REACT_APP_ERROR_HOST;
          }

          return platform === 'msite' ? REACT_APP_ERROR_MYADS_REDIRECT_MSITE : REACT_APP_ERROR_MYADS_REDIRECT;
        };

        Sentry.captureException(error);
        window.location.href = getErrorURL();
      });
  },
});

const mapDispatchToProps = { toggleLoader, fetchPOSData };
const mapStateToProps = state => ({
  loading: isLoading(state),
  posData: getPOSData(state),
  extrasData: getExtrasData(state),
  adData: getAdData(state),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withInitialFetch,
  withLoader,
)(PointOfSale);
